import React, { Component } from "react";
import "../allUser/style/style1.css";

import { users } from "../Users";
import { getDashboardData } from "../services/dashboardServices";

import isURL from "validator/lib/isURL";
import ReactLoading from "react-loading";

import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import * as serviceContext from "../services/serviceContext";
import { getUsers } from "../services/userServices";
import Layout from "./components/Layout";

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: false,
      showUsersNo: 10,
      users: [],
      data: [],
      items: [],
      events: [],
      DataisLoaded: false,
      enabled: false,
      curStatus: false,
      showToast: false,
      toastMessage: "",
    };
    this.updateInput = this.updateInput.bind(this);
  }
  componentDidMount() {
    getDashboardData()?.then((json) => {
      this.setState({
        items: json,
        DataisLoaded: true,
      });
    });
    getUsers()?.then((json) => {
      this.setState({
        users: json,
      });
    } );
  }

  
  toastClose = () => {
    this.setState({ showToast: false });
  };

  updateDashboardData = async (data) => {
    try {
      let options = {};
      const response = await serviceContext.put(
        "/update",
        data,
        options 
      );
      if (response && response[0].result) {
        this.setState({ toastMessage: "Data successfully updated!", showToast: true });
      } else {
        this.setState({ toastMessage: "Data Not updated!", showToast: false });
      }
      return response;
    } catch (error) {
      return error;
    }
  };

  updateDashboardStatus = async (data) => {
    try {
      let options = {};
      const response = await serviceContext.put(
        "/status-update",
        data,
        options
      );
      if (response) {
        this.setState({ toastMessage: "Status Changed Successfully", showToast: true });
      } else {
        this.setState({ toastMessage: "Status Not Changed!", showToast: false });
      }
      
      return response;
    } catch (error) {
      return error;
    }
  };

  updateStatus(id, status) {
    
    let body = {
      id: id,
      t_status: status,
    };
    
    this.updateDashboardStatus(body);

    
  }

  onChangeStatus = (index) => {
    
    this.updateStatus(
      this.state.items[index].id,
      !this.state.items[index].status
    );

    let itemsCopy = JSON.parse(JSON.stringify(this.state.items));
    
    itemsCopy[index].status = itemsCopy[index].status == 1 ? 0 : 1;
    this.setState({
      items: itemsCopy,
    });
  };

  updateInput(event) {
    this.setState({ link: event.target.value });
  }

  onChangeOfInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  updateSettings(id, link) {
    let new_link = "";

    Object.keys(this.state)?.map((Key) => {
      if (Key == id) {
        new_link = this.state[Key];
      }
    });

    let body = {
      id: id,
      link: new_link,
    };
    
    if (
      isURL(new_link) != "" &&
      isURL(new_link) != null &&
      isNaN(new_link) !== false
    ) {
    
      this.updateDashboardData(body);
    } else if (new_link == "" || new_link == null) {
      this.setState({ toastMessage: "Link already exist!" });
      this.setState({ showToast: true });
     
    } else {
      this.setState({ toastMessage: "Invalid URL" });
      this.setState({ showToast: true });
     
    }
  }

  getPaginationGroup() {
    let totalPage = Math.ceil(users.length / this.state.showUsersNo);
    return totalPage;
  }

  render() {
    let pages = this.getPaginationGroup();
    let pageComp = [];
    const { DataisLoaded, items } = this.state;
   

    for (let index = 0; index < pages; index++) {
      pageComp.push(
        <li className="page-item">
          <a
            className="page-link"
            href="/"
            onClick={() => {
              this.pageClick(index + 1);
            }}
          >
            {index + 1}
          </a>
        </li>
      );
    }

    return (
      <>

        <section className="dashboard">
<Layout>


        {!DataisLoaded && <div className="spin">
          <ReactLoading
            type={"spin"}
            color={"#000000"}
            height={"15%"}
            width={"15%"}
          />
        </div>}

                { DataisLoaded &&  <div className="main-pannel white-gradient ">
                  <div className="col-md-12 all-user-content mt-2">
                    <div className="col-md-4 mb-4 mt-md-0">
                     

                      <h3
                        className="font-weight-normal mb-0 all-user-title"
                        id="all_user"
                      >
                        Configuration
                      </h3>
                    </div>
                    <div className="tab-filter">
                     
                      <div className="tab-content">
                        <div
                          className="tab-pane pt-4 active"
                          id="allteam"
                          role="tabpanel"
                        >
                          <div className="row products-row">
                            <div className="col-md-12">
                              <div className="candidates-table-sec">
                                <div className="table-header p-3 pl-4 pr-4">
                                  <div className="row">
                                    
                                    <div className="col-md-3">
                                      <p className="m-0 font-weight-600">
                                        Tools
                                      </p>
                                    </div>
                                    <div className="col-md-4">
                                      <p className="m-0 font-weight-600">
                                        Redirect Link
                                      </p>
                                    </div>
                                    <div className="col-md-3">
                                      <p className="m-0 font-weight-600">
                                        Status
                                      </p>
                                    </div>
                                    <div className="col-md-2">
                                      <p className="m-0 font-weight-600">
                                        OPTION
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="table-user-data candidates-table-list bg-white">
                                  {this.state.filterData
                                    ? this?.state?.data?.map((item) => {
                                        return (
                                          <div
                                            key={item.id}
                                            className="row table-items m-0 align-items-center py-3"
                                          >
                                            <div className="col-md-2">
                                              <button className="btn btn-edit">
                                                Update
                                              </button>
                                            </div>
                                          </div>
                                        );
                                      })
                                    : items?.map((item, i) => {
                                        return (
                                          <div
                                            key={item.id}
                                            className="row table-items m-0 align-items-center py-3"
                                          >
                                            
                                            <div className="col-md-3">
                                              <div className="d-flex name align-items-center">
                                                <div className="name-img mr-3"></div>
                                                <p className="h6 gray-text m-0">
                                                  {item.name}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="col-md-4">
                                              <p className="h6 gray-text m-0">
                                                <input
                                                  type="url"
                                                  pattern="https?://.+"
                                                  id="fname"
                                                  className="form-control-light"
                                                  name={item.id}
                                                  defaultValue={item.link}
                                                  onChange={
                                                    this.onChangeOfInput
                                                  }
                                                />
                                              </p>
                                            </div>
                                            <div className="col-md-3">
                                              <div className="d-flex name align-items-center">
                                                <div
                                                  className="team-img mr-3"
                                                  
                                                >
                                                  
                                                  
                                                  <div className="form-check form-switch form-switch-xl">
                                                    <input
                                                      className="form-check-input"
                                                      onChange={() =>
                                                        this.onChangeStatus(i)
                                                      }
                                                      type="checkbox"
                                                      role="switch"
                                                      id="flexSwitchCheckDefault"
                                                      checked={item.status}
                                                    />
                                                  
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="col-md-2">
                                              <button
                                                className="btn btn-edit"
                                                type="submit"
                                                onClick={() =>
                                                  this.updateSettings(item.id)
                                                }
                                              >
                                                Update
                                              </button>
                                            </div>
                                          </div>
                                        );
                                      })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <nav
                          aria-label="Page navigation example"
                          className="text-center mt-3 d-flex justify-content-center"
                        ></nav>
                      </div>
                    </div>
                  </div>
                </div>}
                </Layout>            
        </section>

        <ToastContainer
          position="top-end"
          className="p-3"
          style={{ zIndex: 1 }}
        >
          <Toast
            onClose={this.toastClose}
            show={this.state.showToast}
            delay={3000}
            autohide
            position="top-end"
          >
            
            <Toast.Body>{this.state.toastMessage}</Toast.Body>
          </Toast>
        </ToastContainer>
      </>
    );
  }
}
export default Settings;